<template>
    <section class="video-embed light pink">
        <circles-layout></circles-layout>
        <ogt-video ref="video" src="/static/video/onderwijskwaliteit2.mp4" :muted="false"></ogt-video>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import OgtVideo from '@/app/components/OgtVideo';
    import Circles from '@/app/components/circles';
    export default {
        name: 'OnderwijskwaliteitVideo',
        meta: {
            title: 'OnderwijskwaliteitVideo',
            color: '#fe1362'
        },
        components: {
            'ogt-video': OgtVideo,
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            }
        }
    };
</script>
